import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { ClientesVmi } from "./ClientesVmi/ClientesVmi";

export const ACTImportarDatos: EntityClientAction = {
    name: 'ACTImportarDatos',
    label: 'Importar Datos',
    title: <Text fw={700}>Importar Datos</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: ['clie_brwStandard'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const clientesVmi = new ClientesVmi(entity.API.client);
        clientesVmi.def.columns.c_cliente_backoffice_id.value = selectedKeys![0].c_cliente_id as unknown as string || '';

        await openEntityForm({
            modals: modal,
            formProps: {
                entity: clientesVmi,
                initialFormMode: 'add',
                getDataOnInit: false
            },
            modalFormSize: 'xl',
            handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(); },
            handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(); }
        });

        return false;
    }
}